import * as React from "react"
import { Box, Chip, Tooltip } from "@mui/material";
import { IconSeeker } from "@ui-seeker/core";

import { ChipBlock } from "../@components"
import { userDetailModalFilters } from "../../@signals";


export default function chipColumn(name, label, limitElements, showInheritedBadge = false) {
    return {
        name: name, label: label,
        options: {
            filter: false,
            setCellProps: () => ({ sx: { maxWidth: 140 } }),
            customBodyRowRenderLite: (value, row) => {
                const accessToShow = value.slice(0, limitElements)

                return <Box display={'flex'} flexDirection={"column"} justifyContent={'center'} alignItems={'center'}>
                    {showInheritedBadge && !row.hasCustomModules
                        ? <Tooltip title="No custom module override — uses the customer's default configuration" placement="top">
                            <Chip
                                icon={<IconSeeker icon="users" sx={{ fontSize: '0.7rem !important', ml: '8px !important' }} />}
                                label="Customer Default"
                                size="small"
                                variant="outlined"
                                sx={{
                                    height: 26,
                                    fontSize: '0.72rem',
                                    color: 'info.main',
                                    borderColor: 'info.main',
                                    mb: 0.5,
                                    cursor: 'help',
                                    opacity: 0.85,
                                }}
                            />
                          </Tooltip>
                        : <>
                            {showInheritedBadge && (
                                <Chip
                                    icon={<IconSeeker icon="user-gear" sx={{ fontSize: '0.7rem !important', ml: '8px !important' }} />}
                                    label="Customer Override"
                                    size="small"
                                    sx={{
                                        height: 26,
                                        fontSize: '0.72rem',
                                        backgroundColor: 'secondary.main',
                                        color: 'secondary.contrastText',
                                        mb: 0.5,
                                    }}
                                />
                            )}
                            <ChipBlock listElements={accessToShow} />
                          </>
                    }
                    <IconSeeker
                        icon="circle-info"
                        tooltip="See user full info"
                        sx={{ ml: 1, fontSize: '1rem', cursor: 'pointer' }}
                        onClick={() => {
                            userDetailModalFilters.value = row
                        }}
                    />
                </Box>
            }
        }
    }
}